// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .button-container {
        display: flex;
        justify-content: space-between;
      }
      .invalid-field {
        border: 1px solid red !important;
        box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.25);
      }
      .mandatory {
        color: red;
      }
      .print-alert {
        margin-top: 1rem;
        padding: 0.75rem;
        background-color: #f8d7da;
        color: #721c24;
        border: 1px solid #f5c6cb;
        border-radius: 0.25rem;
      }
    `, "",{"version":3,"sources":["webpack://./projects/ert/src/app/ert-preplan-rescue/edit-ert-preplan-rescue/edit-ert-preplan-rescue.component.ts"],"names":[],"mappings":";MACM;QACE,aAAa;QACb,8BAA8B;MAChC;MACA;QACE,gCAAgC;QAChC,8CAA8C;MAChD;MACA;QACE,UAAU;MACZ;MACA;QACE,gBAAgB;QAChB,gBAAgB;QAChB,yBAAyB;QACzB,cAAc;QACd,yBAAyB;QACzB,sBAAsB;MACxB","sourcesContent":["\n      .button-container {\n        display: flex;\n        justify-content: space-between;\n      }\n      .invalid-field {\n        border: 1px solid red !important;\n        box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.25);\n      }\n      .mandatory {\n        color: red;\n      }\n      .print-alert {\n        margin-top: 1rem;\n        padding: 0.75rem;\n        background-color: #f8d7da;\n        color: #721c24;\n        border: 1px solid #f5c6cb;\n        border-radius: 0.25rem;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
